<template>
  <div class="block-daily-fortune" :style="styles">
    <swiper :options="swiperOptions">
      <swiper-slide
        class="slide-item"
        v-for="(item, idx) in resultListMod"
        :key="idx"
      >
        <div class="slide-inner">
          <img class="slide-title" :src="`/static/img/recommend/lp/houen/products/title_dailyfortune${idx === 0 ? '_yesterday' : idx === 2 ? '_tomorrow' : ''}.png`" alt="">
          <span class="datetime">{{item.datetime | formatDate}}</span>
          <span class="score-base">
            <img
              v-for="n in 5"
              :src="`/static/img/recommend/lp/houen/products/ic_score_flower${n <= +item.summary ? '' : '_disable'}.svg`"
              :key="`${idx}_f${n}`"
              class="flower"
            >
          </span>
          <p class="description" v-html="item.text"></p>
        </div>
      </swiper-slide>
    </swiper>
    <div class="navbtns-wrap">
      <span class="swiper-button-prev"></span>
      <span class="swiper-button-next"></span>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
moment.locale('ja')

import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'

export default {
  name: 'BlockDailyFortune',
  components: {
    swiper,
    swiperSlide
  },
  props: {
    resultList: {
      type: Array,
    },
    colorScheme: {
      type: Object,
      default() {
        return {}
      }
    },
  },
  computed: {
    resultListMod() {
      return this.resultList
    },
    swiperOptions() {
      return {
        slidesPerView: 1,
        initialSlide: 1,
        spaceBetween: 0,
        centeredSlides: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
    },
    styles() {
      return {
        '--key-color': this.colorScheme.keyColor,
        '--second': this.colorScheme.second,
        '--grad-start': this.colorScheme.gradStart,
        '--grad-end': this.colorScheme.gradEnd,
        '--mess-bg': this.colorScheme.messBg,
      }
    },
  },
  methods: {

  },
  filters: {
    formatDate(val) {
      if(/^(?:19|20)\d{2}-[01]\d-[0-3]\d$/.test(val)){
        const dt = new moment(val)
        return dt.format('YYYY.MM.DD（ddd）')
      }
    },
  },
}</script>

<style scoped lang="scss">

@import "../../../../../../sass/commons/commonVariables.scss";
$l_col_keycolor: var(--key-color);
$l_col_second: var(--second);
$l_col_grad_start: var(--grad-start);
$l_col_grad_end: var(--grad-end);
$l_col_mess_bg: var(--mess-bg);

.block-daily-fortune {
  min-height: 100px;
  position: relative;
  border-radius: 10px;
}
.score-base {
  display: block;
  width: 100%;
  text-align: center;
  line-height: 1;
  margin-bottom: 10px;
  img {
    display: inline-block;
  }
}
.swiper-button-next,
.swiper-button-prev {
  background: url(/static/img/recommend/lp/houen/products/slidearrow_dailyfortune.svg) no-repeat center center;
  background-size: 100% auto;
  width: 24px;
  &.swiper-button-disabled {
    opacity: 0.1;
  }
}
.swiper-button-prev {
  transform: rotate(180deg);
}
.slide-item {
  padding: 10px 10px;
  width: 100%;
  padding-bottom: 40px;
  .slide-inner {
    width: 335px;
    height: 324px;
    margin: auto;
    background: url(/static/img/recommend/lp/houen/products/bg_dailyfortune.svg) no-repeat center center;
    background-size: 100% auto;
  }
  .slide-title{
    width: 116px;
    margin: auto;
    padding-top: 40px;
    padding-bottom: 6px;
  }
  .datetime {
    text-align: center;
    display: block;
    font-weight: 600;
    font-size: 15px;
    line-height: 20px;
    color:$l_col_keycolor;
    margin-bottom: 10px;
  }

  .description{
    width: 255px;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Products/houen/partials/BlockDailyFortune.vue